import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import QueryForm from '../../../Pages/Static/queryForm'
import BulovaBanner from '../../../../Assets/images/alicias-img/bulova.png'
import BulovaBannerMobile from '../../../../Assets/images/alicias-img/bulova-mobile.png'

import { isMobileOnly } from 'react-device-detect'
const Bulova = () => {
  return (
    <>
      <div className='watch_repaire_services_page'>
      <Container fluid>
            <Row>
                <Col sm={12} md={12} lg={12} className="p-0">
                <div>
                   {isMobileOnly? <Image src={BulovaBannerMobile} className='img-fluid'  alt='Oris'/>:<Image src={BulovaBanner} className='img-fluid'  alt='Oris'/>} 
                </div>
                </Col>
            </Row>
      </Container>
      <Container>
          <div className='text-center pt-5'>
            <Row className='justify-content-center'>
              <Col lg={8}>
                <h3 className='text-center text-uppercase'>
                Bulova
                </h3>
                <p>
                  Unleash your style with Bulova, where innovation meets refined elegance. Since 1875, Bulova has been at the forefront of watchmaking, skillfully merging advanced technology with timeless design. Each timepiece is a stunning blend of sophistication and artistry, crafted for those who value both heritage and modernity. Whether you’re making a statement at a special event or elevating your everyday look, a Bulova watch is the perfect accessory that reflects your unique flair. Step into a realm of exceptional craftsmanship and redefine your wristwear with Bulova – where every second is an invitation to express your individuality with confidence and grace.


                </p>
              </Col>
            </Row>

          </div>

        </Container>
      <QueryForm/>
      </div>
    </>
    
  )
}

export default Bulova
